import styled from 'styled-components';
import backgroundImage from './images/background-image.png';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: white;
    background-image: url(${backgroundImage});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
`;

export const TopBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 40px;
    background-color: #f9f9f9;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
`;

export const BrandLogo = styled.img`
    width: 150px;
`;

export const IconsContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const ProfileIcon = styled.img`
    width: 36px;
    height: 36px;
    margin-right: 15px;
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.3s ease;
    padding: 6px;
    background-color: white;

    &:hover {
        border-color: #5D33E2;
        box-shadow: 0px 2px 8px rgba(93, 51, 226, 0.2);
    }
`;

export const SettingsIcon = styled.img`
    width: 36px;
    height: 36px;
    cursor: pointer;
    border-radius: 50%;
    border: 2px solid transparent;
    transition: all 0.3s ease;
    padding: 6px;
    background-color: white;

    &:hover {
        border-color: #5D33E2;
        box-shadow: 0px 2px 8px rgba(93, 51, 226, 0.2);
    }
`;

export const DropdownContainer = styled.div`
    position: relative;
    display: inline-block;
`;

export const DropdownMenu = styled.div`
    position: absolute;
    top: 50px;
    right: 0;
    background-color: white;
    min-width: 280px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    z-index: 1000;
    overflow: hidden;
    border: 1px solid #E0E0E0;
`;

export const DropdownItem = styled.div`
    padding: 12px 20px;
    cursor: pointer;
    color: #333;
    font-size: 14px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 10px;

    &:hover {
        background-color: #F1EAFE;
        color: #5D33E2;
    }

    &:not(:last-child) {
        border-bottom: 1px solid #F5F5F5;
    }
`;

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    backdrop-filter: blur(4px);
`;

export const ModalContainer = styled.div`
    background-color: white;
    border-radius: 16px;
    padding: 30px;
    max-width: 500px;
    width: 90%;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
`;

export const ModalHeader = styled.h2`
    font-size: 24px;
    color: #333;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #757575;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;

    &:hover {
        background-color: #F5F5F5;
        color: #5D33E2;
    }
`;

export const SettingGroup = styled.div`
    margin-bottom: 24px;
`;

export const SettingLabel = styled.label`
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
`;

export const Select = styled.select`
    width: 100%;
    padding: 12px 16px;
    font-size: 14px;
    border: 2px solid #E0E0E0;
    border-radius: 10px;
    background-color: white;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        border-color: #5D33E2;
    }

    &:focus {
        outline: none;
        border-color: #5D33E2;
        box-shadow: 0px 0px 0px 3px rgba(93, 51, 226, 0.1);
    }
`;

export const SaveButton = styled.button`
    width: 100%;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    background-color: #5D33E2;
    color: white;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 8px;

    &:hover {
        background-color: #4a26c0;
        box-shadow: 0px 4px 12px rgba(93, 51, 226, 0.3);
    }

    &:active {
        transform: translateY(1px);
    }
`;

export const ModelDescription = styled.p`
    font-size: 12px;
    color: #757575;
    margin-top: 8px;
    line-height: 1.5;
    font-style: italic;
`;

export const SuccessToast = styled.div`
    position: fixed;
    top: 20px;
    right: 20px;
    background-color: #04F06A;
    color: #333;
    padding: 16px 24px;
    border-radius: 10px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    gap: 10px;
    z-index: 3000;
    animation: slideIn 0.3s ease;
    font-weight: 500;

    @keyframes slideIn {
        from {
            transform: translateX(400px);
            opacity: 0;
        }
        to {
            transform: translateX(0);
            opacity: 1;
        }
    }
`;

export const ErrorToast = styled.div`
    position: fixed;
    top: 20px;
    right: 20px;
    background-color: #dc3545;
    color: white;
    padding: 16px 24px;
    border-radius: 10px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    gap: 10px;
    z-index: 3000;
    animation: slideIn 0.3s ease;
    font-weight: 500;

    @keyframes slideIn {
        from {
            transform: translateX(400px);
            opacity: 0;
        }
        to {
            transform: translateX(0);
            opacity: 1;
        }
    }
`;

export const ConfirmButton = styled.button`
    flex: 1;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;

    &.primary {
        background-color: #5D33E2;
        color: white;

        &:hover {
            background-color: #4a26c0;
        }
    }

    &.secondary {
        background-color: #F5F5F5;
        color: #333;

        &:hover {
            background-color: #E0E0E0;
        }
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 12px;
    margin-top: 24px;
`;

export const MainContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
`;

export const HeaderContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-start;
`;

export const Header = styled.h1`
    font-size: 2em;
    margin-bottom: 40px;
`;

export const TabContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    gap: 20px;
    margin-bottom: 40px;
`;

export const Tab = styled.button`
    padding: 10px 20px;
    font-size: 1em;
    display: flex;
    align-items: center;
    gap: 5px;
    background-color: ${props => (props.selected ? '#F1EAFE' : 'white')};
    color: ${props => (props.selected ? '#5D33E2' : '#757575')};
    border: 2px solid ${props => (props.selected ? '#5D33E2' : '#E0E0E0')};
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: ${props => (props.selected ? '#EDE7F6' : '#F5F5F5')};
    }
`;

export const LanguageSelectorContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const LanguageSelector = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin-left: 20px;
    margin-bottom: 10px;
    gap: 10px;
`;

export const LanguageButton = styled.button`
    background: none;
    border: none;
    color: ${props => (props.selected ? '#5D33E2' : '#000')};
    font-size: 1em;
    font-weight: ${props => (props.selected ? 'bold' : 'normal')};
    padding: 5px 10px;
    cursor: pointer;
    border-bottom: ${props => (props.selected ? '3px solid #5D33E2' : 'none')};
    transition: color 0.3s ease;

    &:hover {
        color: #5D33E2;
    }
`;

export const ChangeLanguageButtonContainer = styled.div`
    display: flex;
    align-items: center;
    margin: 10px;
`;

export const ChangeLanguageIcon = styled.i`
    font-size: 1em;
    cursor: pointer;
    color: #000;
    transition: color 0.3s ease;
    &:hover {
        color: #5D33E2;
    }
`;

export const TextAreasContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: flex-start;
    gap: 40px;
`;

export const TextAreaContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const TextArea = styled.textarea`
    flex-grow: 1;
    height: 300px;
    padding: 20px;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    resize: none;
`;

export const TranslationAreaContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
`;

export const TranslationArea = styled.textarea`
    flex-grow: 1;
    height: 300px;
    padding: 20px;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    resize: none;
`;

export const CopyIcon = styled.i`
    position: absolute;  
    bottom: 20px;
    right: 30px;
    font-size: 1em;
    cursor: pointer;
    color: #000;
    transition: color 0.3s ease;
    &:hover {
        color: #5D33E2;
    }
`;

// Styles pour le conteneur de téléchargement de fichiers
export const FileUploadContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 300px;
    border: 2px dashed #5D33E2;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.3); /* Blanc avec transparence */
    backdrop-filter: blur(10px); /* Ajoute un effet de flou */
    position: relative;
`;

export const FileUploadBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 20px;
    gap: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 100%;
    height: 100%;
    justify-content: center;

    &:hover {
        background-color: rgba(93, 51, 226, 0.05);
    }
`;

export const FileUploadText = styled.p`
    font-size: 1em;
    color: #757575;
`;

export const FileBrowseButton = styled.button`
    padding: 10px 20px;
    font-size: 1em;
    background-color: #5D33E2;
    color: white;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #4a26c0;
    }
`;

// Styles pour la jauge de progression
export const ProgressBarContainer = styled.div`
  position: relative;
  width: 350px;
  height: 20px;
  background-color: #e0e0e0; /* Couleur de fond gris clair */
  border-radius: 10px; /* Coins arrondis */
  margin: 20px auto;
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1); /* Donne un effet de profondeur */
`;

export const ProgressBar = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #5D33E2, #04F06A); /* Dégradé bleu à vert */
  border-radius: 10px; /* Coins arrondis */
  transition: width 0.3s ease; /* Animation fluide lors de la progression */
`;

export const ProgressText = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: white; /* Couleur du texte */
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2); /* Ajoute un léger contour au texte */
`;

// Styles pour le conteneur du robot
export const RobotContainer = styled.div`
    display: flex;
    justify-content: right;
    align-items: center;
`;

export const RobotText = styled.p`
    width: 33%;
    padding: 20px;
    margin-right: 20px;
    border: 2px solid #5D33E2;
    border-radius: 20px;
    background-color: #f9f9f9;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    font-size: em;
    color: #000;
`;

export const RobotImage = styled.img`
    width: 150px;
    height: auto;
`;

export const MetricsContainer = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 12px 16px;
    background-color: #f9f9f9;
    border: 1px solid #E0E0E0;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
`;

export const MetricRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
`;

export const MetricLabel = styled.span`
    color: #757575;
    font-weight: 500;
`;

export const MetricValue = styled.span`
    color: #5D33E2;
    font-weight: 600;
`;
